module.exports = __webpack_public_path__ + "img/rba-japon.7998a4bc.jpg";